import React, { Component, ReactNode } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'

interface ErrorBoundaryProps extends WithTranslation {
    children: ReactNode
}

interface ErrorBoundaryState {
    hasError: boolean
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError(): Partial<ErrorBoundaryState> {
        return { hasError: true }
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        console.error('Error caught by Error Boundary:', error, errorInfo)
    }

    resetError = (): void => {
        // this.setState({ hasError: false })
        window.location.reload()
    }

    render(): ReactNode {
        const { t } = this.props as any
        if (this.state.hasError) {
            return (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        padding: '20px',
                        height: '100%',
                        // maxWidth: '38%',
                        backgroundColor: '#F5FBFF',
                        margin: 'auto',
                    }}
                >
                    <h1 style={{ color: 'red' }}>{t('somethingWentWrong')}</h1>
                    {/* <p>{t('refreshOrTryLater')}</p> */}
                    <p>{t('reloadPageMessage')}</p>
                    <span>
                        {t('supportIntro')}{' '}
                        <a href="mailto:dtcloudservices@deltatrak.com">
                            dtcloudservices@deltatrak.com
                        </a>
                    </span>
                    <span>
                        {t('orCall')}{' '}
                        <a href="tel:+18003900804">800-390-0804</a> (
                        {t('option')} 4) {t('orReachUsAt')}{' '}
                        <a href="tel:+19252492250">925-249-2250</a> {t('ext')}{' '}
                        5124.
                    </span>

                    <div style={{ marginTop: '20px' }}>
                        {/* Try Again Button */}
                        <button
                            onClick={this.resetError}
                            style={{
                                marginRight: '10px',
                                padding: '10px 20px',
                                backgroundColor: '#007bff',
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                fontWeight: '800',
                            }}
                        >
                            {/* {t('tryAgain')} */}
                            {t('refresh')}
                        </button>

                        {/* Go to Home Button (Resets Error Before Navigation) */}
                        {/* <Link
                            to="/"
                            onClick={this.resetError}
                            style={{ textDecoration: 'none' }}
                        >
                            <button
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#28a745',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                }}
                            >
                                {t('goToHome')}
                            </button>
                        </Link> */}
                    </div>
                </div>
            )
        }
        return this.props.children
    }
}

export default withTranslation()(ErrorBoundary)
